export let modifcarShoppingCart=(valor)=>{ return {type:"MODIFY",payload:valor} };
export let estadoShoppingCart=(valor)=>{ return {type:"ESTADO",payload:valor} };